import $get from 'lodash.get'
import $merge from 'lodash.merge'

import {
  findPageFromSlug,
  genAvatarFn,
  getConfig,
  getConfigStrict,
  getCardsImagesGradients,
  getRoutes,
  getShellConfig,
  getSSOProviders,
  getThemeConfig,
  getThemeConfigProperty,
  setContext,
  headTitle,
  headDescription,
  hasDisabledComponent,
  hasMatomoEnabled,
  hasLocalAuthModeUniquePassword,
  isThemeDark,
  useLocalAuth,
} from '~/utils/voicer'

export default (context, inject) => {
  const { app } = context
  const { site } = app.store.state.root

  if (!site) {
    throw new Error(`missing site entity in store`)
  }

  setContext(context)

  // configure some elements

  const isIE = !!window.MSInputMethodContext && !!document.documentMode
  const isStandalone = !!navigator.standalone

  const locale = context.i18n.locales.some(
    (locale) => locale.code === context.i18n.locale
  )
    ? context.i18n.locale
    : 'fr'

  const $voicer = {
    avatarsLibrary: genAvatarFn(),
    canUseLocalRegistration() {
      return site.optRegistrable === true
    },
    canUseLocalSignin() {
      return useLocalAuth()
    },
    captureException(exception) {
      // todo: send event to brocoli events
      throw exception
    },
    headTitle: headTitle(app.$metadatas.siteHeadTitle),
    headDescription: headDescription(app.$metadatas.siteHeadTitle),
    findPageFromSlug,
    getConfig,
    getConfigStrict,
    getShellConfig,
    getImageGradient() {
      const gradients = getCardsImagesGradients(context)

      return this.isMobile ? gradients.mobile : gradients.desktop
    },
    getLastVisitedRoute() {
      return context.store.getters['root/lastVisitedRoute']
    },
    getRoutes,
    getSSOProviders,
    getThemeConfig,
    getThemeConfigProperty: getThemeConfigProperty(context),
    hasDisabledComponent,
    hasMatomoEnabled: hasMatomoEnabled(),
    hasLocalAuthModeUniquePassword,
    enabledComponent: (name) => {
      return hasDisabledComponent(name) === false
    },
    isDarkTheme: isThemeDark(),
    isLightTheme: isThemeDark() === false,
    isOpenSite: function isOpenSite() {
      const site = context.app.store.state.root.site

      return $get(site, 'optAuthentication') === false
    },
    isIE,
    isIos: context.$device.isIos,
    isStandalone,
    isMobile: context.$device.isMobile,
    isMobileOrTablet: context.$device.isMobileOrTablet,
    isTablet: context.$device.isTablet,
    isDesktop: context.$device.isDesktop,
    isDesktopOrTablet: context.$device.isDesktopOrTablet,
    isUniverse: getConfig('useShell[1].mode') === 'universes',
    collections: getConfig('useShell[1].universes'),
    isThemeDark,
    locale,
    screenWidth() {
      return window.screen.width
    },
    site,
    conditioner: function themeConditionExecutor() {
      return new (class Executor {
        properties = undefined

        apply(something) {
          if (typeof something === 'object') {
            this.properties = $merge({}, this.properties, something)
          } else {
            this.properties = something
          }
        }

        ifLight(doSomething) {
          if (isThemeDark() === false) {
            this.apply(doSomething)
          }

          return this
        }

        ifDark(doSomething) {
          if (isThemeDark()) {
            this.apply(doSomething)
          }

          return this
        }

        render() {
          return this.properties
        }
      })()
    },
  }

  inject('voicer', $voicer)
}
